export const SET_CRM_INTEGRATION = "SET_CRM_INTEGRATION";
export const GET_CRM_INTEGRATION = "GET_CRM_INTEGRATION";
export const CLEAR_CRM_INTEGRATION = "CLEAR_CRM_INTEGRATION";
